import { useState, useEffect, useCallback } from 'react';
import { insightsApi, InsightsData } from '../api/insights';

export function useInsights() {
  const [data, setData] = useState<InsightsData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [lastFetchedAt, setLastFetchedAt] = useState<Date | null>(null);

  const fetch = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await insightsApi.get();
      setData(result);
      setLastFetchedAt(new Date());
    } catch {
      setError('Failed to load insights. Please try again.');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetch();
  }, [fetch]);

  // Re-fetch on tab focus (if data is older than 60s)
  useEffect(() => {
    const onFocus = () => {
      if (!lastFetchedAt) return;
      if (Date.now() - lastFetchedAt.getTime() > 60_000) fetch();
    };
    document.addEventListener('visibilitychange', onFocus);
    return () => document.removeEventListener('visibilitychange', onFocus);
  }, [fetch, lastFetchedAt]);

  return { data, isLoading, error, refetch: fetch, lastFetchedAt };
}
